import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Input from '../../../../../components/Input';
import Select from '../../../../../components/Select';
import styles from './LedgerPath.module.scss';
import { OptionType } from '../../../../../types';
import { CoinPath, CoinType, CoinTypeLabel } from '../../../../../enum';
import ModalFooter from '../../../../../components/ModalFooter';

type Props = {
  onCancel: () => void;
  onConfirm: (type: CoinType, path: string) => void;
}

const LedgerPath: React.FC<Props> = ({ onCancel, onConfirm }) => {
  const { t } = useTranslation();
  const [path, setPath] = useState<string>('');
  const [type, setType] = useState<string>('');

  const options: OptionType[] = [
    // todo support btc
    // {
    //   label: CoinTypeLabel.BTC,
    //   value: CoinType.BTC,
    // },
    {
      label: CoinTypeLabel.ETH,
      value: CoinType.ETH,
    },
  ];

  const handleChange = (val: string) => {
    setType(val);
    if (val === CoinType.BTC) {
      setPath(CoinPath.BTC);
    } else if (val === CoinType.ETH) {
      setPath(CoinPath.ETH);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.tip}>{t('please_enter_info')}</div>
      <Select
        value={type}
        onChange={handleChange}
        options={options}
        placeholder={t('select_type')}
        space={false}
      />
      <Input
        value={path}
        onChange={setPath}
        placeholder={t('enter_path')}
      />
      {
        type && <div className={styles.ledgerTip}>{t('ledger_tip')}</div>
      }
      <ModalFooter
        disable={!(type && path)}
        onCancel={onCancel}
        onConfirm={() => onConfirm(type as CoinType, path)}
      />
    </div>
  );
};

export default LedgerPath;
